export const parseQueryString = (search) => {
  if (!search || typeof search !== "string") {
    return {};
  }

  const queryStartIndex = search.indexOf("?");
  if (queryStartIndex === -1) {
    return {};
  }

  const query = search.slice(queryStartIndex + 1);
  if (!query) {
    return {};
  }

  const params = new URLSearchParams(query);
  const result = {};
  for (const [key, value] of params.entries()) {
    if (!key) {
      continue;
    }
    result[key] = value;
  }
  return result;
};

export const combineHashSearchQueryString = location => {
  return {...parseQueryString(location.search), ...parseQueryString(location.hash)};
};

export const removeSearch = pathname => {
  const safePathname = pathname ?? "";
  return safePathname.substring(0, safePathname.indexOf("?"));
};

export const stringifyQueryStringObject = queryString => {
  const entries = Object.entries(queryString ?? {});
  if (entries.length === 0) {
    return "";
  }

  const params = new URLSearchParams();
  for (const [key, value] of entries) {
    if (!key) {
      continue;
    }
    params.append(key, String(value ?? ""));
  }

  const query = params.toString();
  return query === "" ? "" : `?${query}`;
};